<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "ChromoSeek",
  mounted() {
    this.$store.dispatch('user/load');
  },
  methods: {
    check() {

    }
  }
}
</script>

<style>
/* CSS */
body {
  display: initial;
  margin: initial;
}

@font-face {
  font-family: 'HiraginoSansGB';
  src: url('./fonts/HiraginoSansGB.ttf') format('truetype');
}

p {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue